export const POWER_BI_EMBED_CONFIG_REQUEST = "POWER_BI_EMBED_CONFIG_REQUEST";
export const POWER_BI_EMBED_CONFIG_SUCCESS = "POWER_BI_EMBED_CONFIG_SUCCESS";
export const POWER_BI_EMBED_CONFIG_FAILURE = "POWER_BI_EMBED_CONFIG_FAILUREA";

export const RESET_POWER_BI_EMBED_CONFIG_STATE = "RESET_POWER_BI_EMBED_CONFIG_STATE";